import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from '../locales/en.json';
import itTranslations from '../locales/it.json';

const resources = {
  en: {
    translation: enTranslations
  },
  it: {
    translation: itTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Supported languages
    supportedLngs: ['en', 'it'],
    
    // Default namespace
    defaultNS: 'translation',
    
    // React i18next options
    react: {
      useSuspense: false,
    },
  });

export default i18n; 